// Bridges the chatbot_sso SDK (React-side) to the framework-agnostic hubClient.
// AuthProvider/AppGate register the SDK's `auth.apiFetch` here once authenticated;
// hubClient routes every request through it so each call carries a Bearer
// access_token (with the SDK's built-in 401-refresh-and-retry). Before
// registration (or if it's cleared on logout) hubClient falls back to plain
// fetch, which will be rejected by the hub — by design, requests should only
// fire once authenticated.
type AuthedFetch = (url: string, init?: RequestInit) => Promise<Response>;

let authedFetch: AuthedFetch | null = null;

export function setAuthedFetch(fn: AuthedFetch | null): void {
  authedFetch = fn;
}

export function getAuthedFetch(): AuthedFetch | null {
  return authedFetch;
}
